import React from 'react';

import classnames from 'classnames';

import styles from './Skeleton.module.scss';

const Skeleton = ({ className }: { className: string }) => <div className={classnames(className, styles.skeleton)} />;

export default Skeleton;
